module.exports = "ui-brandName = { -product-name }\n"